import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Utilisateur } from '@estel-numerique/galaclick-api';
import { TraductionCoreService } from '@estel-numerique/galaclick-core';
import { PlanJourEveType } from '../../models/plan-jour-eve-type.model';
import { PlanJourEve } from '../../models/plan-jour-eve.model';
import { PlanJour } from '../../models/plan-jour.model';
import { TooltipGalaDirective } from '../../../../composants/tooltip-gala/tooltip-gala.directive';
import { DateFormatPipe } from '../../../../../services/util/pipe';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'plan-jour-agent',
    templateUrl: './plan-jour-agent.component.html',
    styleUrls: ['./plan-jour-agent.component.scss'],
    imports: [TooltipGalaDirective, DateFormatPipe]
})
export class PlanJourAgentComponent implements OnChanges {
    public translate = inject(TranslateService);
    protected traductionCore = inject(TraductionCoreService);
    public sanitizer = inject(DomSanitizer);

    @Input() agent: Utilisateur;
    @Input() jour: PlanJour;

    public evenements: PlanJourEve[];
    public nbEvenements: number;

    PlanJourEveType: typeof PlanJourEveType = PlanJourEveType;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.jour || changes.agent) {
            this.setEvenementJour();
        }
    }
    private setEvenementJour() {
        let evts: PlanJourEve[] = [];
        if (this.agent && this.jour) {
            evts = this.jour.agentsEve.get(String(this.agent.USRID));
            if (evts !== undefined) {
                const nbEvenements = evts.length;
                this.evenements = evts;
                this.nbEvenements = nbEvenements;
            }
        }
    }
}
